import React, { useEffect, useState } from 'react';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { setCleanTextAreaError } from '../../../../utils/utils';

interface Props {
    reason: string;
    setReason: (reason: string) => void;
    errorFields?: any;
}

const UnlockStateForm = ({
    reason,
    setReason,
    errorFields,
}: Props) => {

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const { fieldErrorMessage, fieldHasError, setErrors } = useHandleErrorFields();

    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        const { name, value } = event.target;
        setReason(value);
    };


    return (
        <>
            <div className="mb-2 row needs-validation">
                <div className="col-md-12">
                    <label className="col-form-label">Indique el motivo del desbloqueo</label>
                    <textarea
                        className={`form-control ${fieldHasError('reason')}`}
                        name="description"
                        id="description"
                        value={reason}
                        onChange={handleChange}
                        placeholder="Ingrese una descripción"
                        onFocus={setCleanTextAreaError}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('reason')}
                    </div>
                </div>
            </div>
        </>
    );
};

export default UnlockStateForm;
